import Layout from "../../../layout"
import { ReactSVG } from "react-svg"

// ---------------------------------------------------------

import Button from "@components/button"
import ChuckPricing from "@components/chuck/pricing"
import ChuckCodeSnippet from "@components/chuck/code-snippet"
import Grid from "@components/grid"
import Image from "@components/image"
import LogoTrain from "@components/logo-train"
import Quote from "@components/quote"
import Video from "@components/video"
import SVG from "@components/image/svgs"

import { logos } from "@components/logo-train/fixtures"
import fixtures from "@components/chuck/fixtures.js"

// ---------------------------------------------------------

import {
  chuck_page,
  chuck_hero,
  chuck_hero_content,
  chuck_label,
  chuck_mascot_container,
  chuck_mascot,
  chuck_demo_container,
  button_container,
  learn_more_container,
  learn_more,
  learn_more_content,
  benefits_header,
  benefits_section,
  benefit_item,
  features_grid_container,
  features_glow,
  features_nested_content,
  features_copy_grid,
  features_spacer
} from "./styles.module.scss"

// ---------------------------------------------------------

const Chuck = () => {
  return (
    <Layout
      pageTitle="Chuck"
      className={chuck_page}
      excerpt="Meet Chuck, your customer data’s new best friend. Chuck embeds Amperity's customer data expertise into command-line AI that works natively in Databricks."
      featuredImage={fixtures.featuredImage}
      navSettings={{ hideNavRight: true }}
    >
      {/* Hero */}
      <Grid backgroundColor="off-black" centerText className={chuck_hero} width="medium">
        <SVG
          src="https://images.ctfassets.net/5vqt5w81x2im/64I8XBDUvDckE3yl0Znk4L/02abb992072eae830179a89d4f981566/Chuck_Logo_White_NoAmperity.svg"
          title="Chuck horizontal logo"
          className={chuck_label}
        />
        <h1>Command-line AI for customer data</h1>
        <div className={chuck_hero_content}>
          <p>
            Meet Chuck, your customer data’s new best friend. Chuck embeds Amperity's customer data
            expertise into command-line AI that works natively in Databricks.
          </p>
          <ChuckCodeSnippet />
          <div className={button_container}>
            <Button theme="arrow-horizontal-light" url={fixtures.githubLink}>
              Documentation
            </Button>
          </div>
        </div>
      </Grid>

      {/* Demo */}
      <Grid
        paddingTop="none"
        width="medium"
        column={1}
        backgroundColor="off-black"
        centerText
        anchorId="demo"
        className={chuck_demo_container}
      >
        <h6 className={chuck_label}>Chuck explained in 3 mins</h6>
        <Video
          videoUrl="https://youtu.be/E3BBaLPYukA"
          thumbnail={fixtures.chuckVideoThumbnail}
          playIconDefault={`/img/Chuck_Play_Pixel_Default.svg`}
          playIconHover={`/img/Chuck_Play_Pixel_Hover.svg`}
        />
        <div className={chuck_mascot_container}>
          <ReactSVG className={chuck_mascot} {...fixtures.chuckMascot} />
        </div>
      </Grid>

      {/* Logo Train */}
      <LogoTrain
        backgroundColor="midnight"
        label="Amperity is trusted by industry leaders"
        logos={logos}
        topAndBottomPadding="small"
      />

      {/* 2-col Grid */}
      <Grid backgroundColor="off-black" column={2} paddingTop="large" className={benefits_section}>
        <div className={benefits_header}>
          <ReactSVG alt="Command prompt icon" src="/img/Icon_Chuck_Terminal.svg" />
          <h2>Built for data engineers</h2>
        </div>
        <div>
          {fixtures.benefits.map((benefit, index) => (
            <div className={benefit_item} key={index}>
              <h4>{benefit.header}</h4>
              <p>{benefit.description}</p>
            </div>
          ))}
        </div>
      </Grid>

      {/* Features */}
      <Grid width="default" className={features_grid_container} backgroundColor="off-black">
        <div className={features_glow}></div>
        <div className={features_nested_content}>
          <div className={features_copy_grid}>
            <h3>What you can do with Chuck</h3>
            {fixtures.featuresData.map((feature, index) => (
              <div key={index}>
                <h5>{feature.title}</h5>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
          <Image
            alt="Terminal window with prompt 'what customer data do I have?'"
            height={700}
            src="https://images.ctfassets.net/5vqt5w81x2im/3c1lQdprr3L19VqAF4FWxJ/0cf85283803587be618aec7621f1adbb/Demo_ChuckData_WhatYouCanDo.png"
            width={1080}
          />
        </div>
      </Grid>
      <div className={features_spacer}></div>

      <Quote {...fixtures.quote} />

      <ChuckPricing />

      {/* Learn more */}
      <div className={learn_more_container}>
        <div className={learn_more}>
          <div className={learn_more_content}>
            <h2>Get Started with Chuck Data</h2>
            <ChuckCodeSnippet />
            <div className={button_container}>
              <Button
                label="Documentation"
                theme="arrow-horizontal-light"
                url={fixtures.githubLink}
              >
                Documentation
              </Button>
              <Button label="Watch demo" theme="arrow-horizontal-light" url="#demo">
                Watch demo
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Chuck
